module.exports = __webpack_public_path__ + "img/about-smEn.a50aa27d.png";